const emailBody = `
  <body>
{{body}}
  </body>`;
export default emailBody;
